import React from 'react';
import PropTypes from 'prop-types';
import DashboardCard from './DashboardCard';
import i18n from '../../src/i18n/translate';
import orderBy from 'lodash/orderBy';

const AnnouncementCard = ({ systemMessages = [], emptyStateImage }) => {
  const getEmptyComponent = () => (
    <>
      <img src={emptyStateImage} />
      <div>{i18n.t("There are no announcements at this time.")}</div>
    </>
  );

  const announcements = orderBy(systemMessages.filter(item => item.view_locations.includes('dashboard')), ['updated_at'], ['desc']);
  
  return (
    <DashboardCard 
      type="announcement"
      title={i18n.t('Announcements')}
      items={announcements} 
      emptyComponent={getEmptyComponent()}
      getItemCardProps={announcement => ({
        title: announcement.title,
        description: announcement.content,
        hasRichTextContent: true
      })}
    />
  );
}

AnnouncementCard.propTypes = {
  systemMessages: PropTypes.array,
  emptyStateImage: PropTypes.string
};

export default AnnouncementCard;
